import { Stack, Typography } from "@mui/material";
import { BatchPaymentRow } from "Components/BatchPayments/BatchPaymentRow";
import type { BatchPaymentListItemDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Banking.BatchPayments;

type Props = {
  items: BatchPaymentListItemDto[];
  totalCount?: number;
};

export const BatchPaymentListContent = ({ items, totalCount }: Props) => {
  const { t } = useResource();

  const title =
    totalCount !== undefined
      ? `${t(RESOURCES.Title)} (${totalCount})`
      : t(RESOURCES.Title);

  if (items.length === 0) {
    return (
      <Stack>
        <Typography fontWeight={600}>{title}</Typography>
        <Typography marginTop={({ spacing }) => spacing(2)}>
          {t(RESOURCES.EmptyList)}
        </Typography>
      </Stack>
    );
  }

  return (
    <Stack>
      <Typography fontWeight={600}>{title}</Typography>
      {items.map((item) => (
        <BatchPaymentRow key={item.publicId} item={item} />
      ))}
    </Stack>
  );
};
